import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { BenefitsByMonth } from 'src/app/shared/models/benefits.models';

@Component({
  selector: 'app-calendar-pay-month',
  templateUrl: './calendar-pay-month.component.html',
  styleUrls: ['./calendar-pay-month.component.scss'],
})
export class CalendarPayMonthComponent implements OnInit, AfterViewInit {

  @Input() monthWithBenefits: BenefitsByMonth;
  @Input() indice: number;

  constructor(private utils: UtilsService) { }

  ngOnInit() {
    for (let i = 0; i < this.monthWithBenefits.benefits.length; i++) {
      this.monthWithBenefits.benefits[i]['month'] = this.utils.parseMonthShort(this.monthWithBenefits.date[1]);
      this.monthWithBenefits.benefits[i]['day'] = this.monthWithBenefits.benefits[i]['date'][2];
      this.monthWithBenefits.benefits[i]['fullDate'] = `${this.monthWithBenefits.benefits[i]['date'][2]}/${this.monthWithBenefits.benefits[i]['date'][1]}/${this.monthWithBenefits.benefits[i]['date'][0]}`;
      this.monthWithBenefits.benefits[i]['showBreakdown'] = false;
    }

    if (this.monthWithBenefits.benefits) {
      this.monthWithBenefits.benefits.sort((a, b) => {
        const dateA = new Date(a.date![0], a.date![1] - 1, a.date![2]);
        const dateB = new Date(b.date![0], b.date![1] - 1, b.date![2]);
        return dateA.getTime() - dateB.getTime();
      });
    }
  }

  ngAfterViewInit() {
    for (let i = 0; i < this.monthWithBenefits.benefits.length; i++) {
      const el = document.getElementById(`breakdown-${this.indice}-${i}`);
      if (el) {
        el.style.height = '0px';
        el.style.transition = 'height 0.5s';
      }
    }
  }

  toggleBreakdown(benefit: any, index: number) {
    benefit.showBreakdown = !benefit.showBreakdown;
    const el = document.getElementById(`breakdown-${this.indice}-${index}`);
    if (el) {
      el.style.height = benefit.showBreakdown ? `${el.scrollHeight}px` : '0px';
    }
  }
}
